/**
 * Workspace-wide assistant, opened from the rail. Renders the same ChatPane
 * as the right panel with the scope pinned, so there is one implementation of
 * the transcript, the composer and the streaming glue.
 */
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { create } from "zustand";
import { IconButton } from "@/ui/IconButton";
import { ChatPane } from "@/chat/ChatPane";
import s from "./ProjectChatDialog.module.css";

interface ProjectChatStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useProjectChat = create<ProjectChatStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

export function ProjectChatDialog() {
  const open = useProjectChat((p) => p.open);
  const setOpen = useProjectChat((p) => p.setOpen);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className={s.overlay} />
        <Dialog.Content className={s.dialog} aria-describedby={undefined}>
          <div className={s.head}>
            <Dialog.Title className={s.title}>Claude, across Notes, Tasks and Cards</Dialog.Title>
            <Dialog.Close asChild>
              <IconButton label="Close">
                <X size={16} />
              </IconButton>
            </Dialog.Close>
          </div>
          <div className={s.body}>
            <ChatPane forceScope={{ kind: "workspace", noteId: null }} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
